import styled from 'styled-components';
import { Text } from '~/components/typography';

export const BannerWrapper = styled.div`
  align-items: center;
  background: ${props => props.theme.colors.background.accent1};
  display: flex;
  min-height: ${props => props.theme.space[7]};
  justify-content: center;
  padding: 16px;
  z-index: 3;

  img {
    height: 16px;
    z-index: 3;
  }
`;

export const BannerCopy = styled(Text).attrs({ size: 'small' })`
  && {
    color: ${props => props.theme.colors.content.primary};
    font-family: ${props => props.theme.fontFamilies.main.medium};
    font-size: ${props => props.theme.fontSizes[400]};
    line-height: 1;
    margin-left: 8px;
    max-width: none;
    width: auto;
  }
`;
